import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';
import { ensureEnumNumber } from '@texas/utils/helpers/enumHelpers';

export function getChatEntityColor(type: ChatMessageEntityLinkType): string {
  switch (ensureEnumNumber(ChatMessageEntityLinkType, type)) {
    case ChatMessageEntityLinkType.Concept:
      return 'entities.concept';
    case ChatMessageEntityLinkType.Customer:
      return 'entities.customer';
    default:
      return 'entities.metadata';
  }
}
